module.exports = __webpack_public_path__ + "settings.14be9cb6fa216f3b006a1601b14fc7db.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/settings.svg
// module id = 355
// module chunks = 0